import React from 'react';
import './index.scss';
import classNames from 'classnames';
// import { CopyRightLink } from '../../copy-right-link';
import SelectStudioPushpin from '../../../../assets/img/select-studio-pushpin.png';
import SelectStudioCartoonFigure from '../../../../assets/img/select-studio-cartoon-figure.png';
import SelectStudioInGame from '../../../../assets/img/select-studio-ingame.png';

interface IProps {
  readonly title: React.ReactNode | string;
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly isShowBrandLogo?: boolean;
  readonly renderBackgroundIcons?: React.ReactNode;
}

export const SimpleCardWrapper = (props: IProps) => {
  return (
    <div className={classNames('simpleCardWrapper', props.className)}>
      <div className="layout">
        <div className="cardContent">
          {props.renderBackgroundIcons}
          <h4 className="title">{props.title}</h4>
          {props.children}
          <img src={SelectStudioPushpin} className="select-studio-pushpin" />
          <img
            src={SelectStudioCartoonFigure}
            className="select-studio-cartoon-figure"
          />
          <img src={SelectStudioInGame} className="select-studio-ingame" />
        </div>
      </div>
      {/* <CopyRightLink /> */}
    </div>
  );
};

interface IBackgroundIconProps {
  readonly index: number;
  readonly isEmpty: boolean;
}
export const BackgroundIcon = (props: IBackgroundIconProps) => {
  const className = classNames('icon', {
    [`studio-${props.index}`]: true,
    [`studio-${props.index}-empty`]: props.isEmpty,
  });
  return <i className={className} />;
};
